import HeaderBar from "@/components/ui/HeaderBar";
import BottomTabBar, { AstroPrognosisTab } from "@/components/ui/BottomTabBar";
import { UI_STYLES } from "@/styles/uiStyles";
import { motion } from "framer-motion";
import { useAstroPrognosisScreenViewModel } from "./AstroPrognosisScreenViewModel";
import { PrognoseTopBar } from "@/components/ui/PrognoseTopBar";
import ScreenLoader from "@/components/ui/ScreenLoader";
import { useSafariPadding } from "@/hooks/useSafaryPadding";
import { Helmet } from "react-helmet-async";

export default function AstroPrognosisScreen() {

  const {
    prognoses,
    selectedPrognose,   
    selectPrognosis,
    navigateToHome,
    navigateToZodiacPrognosis, 
    isLoading,
  } = useAstroPrognosisScreenViewModel(); 

  const paddingBottom = useSafariPadding();
  return (
    <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3, ease: "easeInOut" }}
    className={`h-full ${UI_STYLES.backgroundDarkBlue}`}
  >
          <Helmet>
        <title>Астрологический прогноз на неделю | Мир Звёзд</title>
        <meta name="description" content="Получите детальный астрологический прогноз на неделю от профессиональных астрологов. Узнайте влияние планет на вашу жизнь, важные даты и рекомендации для каждого дня. Персональные астрологические советы для принятия важных решений." />
        <meta name="keywords" content="астрологический прогноз, недельный прогноз, влияние планет, астрология, гороскоп на неделю, астрологические советы, персональный прогноз, астрологическая консультация" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Астрологический прогноз на неделю | Мир Звёзд" />
        <meta property="og:description" content="Получите детальный астрологический прогноз на неделю от профессиональных астрологов. Узнайте влияние планет на вашу жизнь, важные даты и рекомендации для каждого дня." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://мир-звезд.рф/astro-prognosis" />
      </Helmet>
      <ScreenLoader isLoading={isLoading} />
    <div
      className={`flex flex-col h-full`}
      style={{
        paddingBottom: `max(calc(env(safe-area-inset-bottom, 0px)), ${paddingBottom}px)`,
      }}
    >
      {/* Верхняя панель */}
      <HeaderBar title="Астрологический прогноз" onBack={navigateToHome} />
      {/* Табы недель */}

      <div className="px-4 mb-2 max-w-xl mx-auto w-full ">
        <PrognoseTopBar prognoses={prognoses} selectedPrognose={selectedPrognose} selectPrognosis={selectPrognosis} />
      </div>
      {/* Прогноз */}
      <div className="flex-1 flex flex-col items-center w-full max-w-xl mx-auto w-full min-h-[700px] overflow-y-auto text-white text-sm leading-relaxed text-center hide-scrollbar">
        <div
          className={`w-full ${UI_STYLES.bgDarkBlue4} rounded-2xl p-4 text-white text-sm leading-relaxed text-justify whitespace-pre-line mb-[300px]`}
        >
          {selectedPrognose?.text}
        </div>
      </div>
      {/* Tab Layout */}
      <BottomTabBar
        activeTab={AstroPrognosisTab.Astro}
        onAstroPrognosisClick={() => {}}
        onZodiacPrognosisClick={() => navigateToZodiacPrognosis()}
      />
    </div>
    </motion.div>
  );
}
